<article
  class="w-full h-16 bg-transparent hover:bg-zinc-500/[.05] transition-colors rounded-lg grid p-2 gap-2 cursor-pointer">
  <div class="w-[50px] h-[50px] rounded-md bg-zinc-600/40"></div>
  <div class="flex mt-1">
    <div class="hidden sm:flex sm:flex-col max-w-[80%] overflow-hidden whitespace-nowrap gap-2">
      <p class="rounded-sm bg-zinc-600/40 w-40 h-5"></p>
      <p class="rounded-sm bg-zinc-600/40 w-32 h-3"></p>
    </div>
  </div>
</article>